// ── Color conversion helpers ────────────────────────

function srgbToLinear(c: number): number {
  return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}

export function hexToLinear(hex: string): { r: number; g: number; b: number } {
  const n = parseInt(hex.replace("#", ""), 16);
  return {
    r: srgbToLinear(((n >> 16) & 0xff) / 255),
    g: srgbToLinear(((n >> 8) & 0xff) / 255),
    b: srgbToLinear((n & 0xff) / 255),
  };
}

/** Hex → normalized 0-1 (NO gamma conversion). For clearValue on bgra8unorm canvas. */
export function hexToSrgb(hex: string): { r: number; g: number; b: number } {
  const n = parseInt(hex.replace("#", ""), 16);
  return {
    r: ((n >> 16) & 0xff) / 255,
    g: ((n >> 8) & 0xff) / 255,
    b: (n & 0xff) / 255,
  };
}

// ── South Seas palette (sRGB hex) ───────────────────

export const PALETTE = {
  void: "#030810",
  sand: "#e6ccb2",
  sapphire: "#2a7da3",
  shallows: "#a8ccd6",
  coral: "#c17853",
} as const;

// ── Shared GPU values ───────────────────────────────

export const GPU_SHALLOWS = hexToLinear(PALETTE.shallows);
export const GPU_CORAL = hexToLinear(PALETTE.coral);
export const GPU_SAPPHIRE = hexToLinear(PALETTE.sapphire);
export const GPU_CLEAR_SAND = hexToSrgb(PALETTE.sand);
export const GPU_CLEAR_VOID = hexToSrgb(PALETTE.void);

// ── Third-party palette tokens ──────────────────────

export const GRUVBOX = {
  bg: "#282828",
  fg: "#ebdbb2",
  fgMuted: "#a89984",
  accent: "#d79921",
  green: "#98971a",
  aqua: "#689d6a",
  glassRgb: "40,40,40",
  border: "rgba(255,255,255,0.10)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(235,219,178,0.20)",
  selection: "#d79921",
  selectionText: "#282828",
  noiseOpacity: "0.04",
} as const;

export const DARKULA = {
  bg: "#282a36",
  fg: "#f8f8f2",
  fgMuted: "#6272a4",
  accent: "#ff79c6",
  cyan: "#8be9fd",
  purple: "#bd93f9",
  glassRgb: "40,42,54",
  border: "rgba(255,255,255,0.10)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(248,248,242,0.20)",
  selection: "#ff79c6",
  selectionText: "#282a36",
  noiseOpacity: "0.04",
} as const;

export const FOAM = {
  bg: "#e8f0ec",
  text: "#3d6b5e",
  accent: "#c17853",
} as const;
